var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"require-identity",rawName:"v-require-identity"}],key:"popper-ref",staticClass:"emote-popper-reference",class:{
        disabled: !_vm.isAllowedToEmote,
        'is-active': _vm.isPopperActive
    },attrs:{"id":_vm.referenceId,"title":_vm.title},on:{"click":_vm.togglePopper}},[_c('span',{staticClass:"icon"},[_c('Emote',{attrs:{"emote":_vm.triggerEmoji,"size":14}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }